module.exports = __webpack_public_path__ + "img/web.c8376158.svg";